import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../admin/firebase/config';

/**
 * Hook to check if shop is online/offline
 * Listens to Firebase settings in real-time
 */
export const useShopStatus = () => {
  const [shopOnline, setShopOnline] = useState(true); // Default to online
  const [loading, setLoading] = useState(true);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    const settingsRef = doc(db, 'settings', 'app_settings');

    const unsubscribe = onSnapshot(
      settingsRef,
      (doc) => {
        if (doc.exists()) {
          const data = doc.data();
          setSettings(data);
          setShopOnline(data.shopOnline !== undefined ? data.shopOnline : true);
        } else {
          // If no settings exist, assume shop is online
          setShopOnline(true);
        }
        setLoading(false);
      },
      (error) => {
        console.error('Error fetching shop status:', error);
        // On error, default to online
        setShopOnline(true);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  return { shopOnline, loading, settings };
};

export default useShopStatus;
